"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newSkills = void 0;
exports.newSkills = [
    {
        name: "Catch",
        family: "Agility",
        mode: "Active",
        summary: "Relance un test d'Agilité raté pour attraper le ballon.",
    },
    {
        name: "Defensive",
        family: "Agility",
        mode: "Passive",
        summary: "Empêche les adversaires marqués d'utiliser Guard ou Put the Boot In.",
    },
    {
        name: "Diving Catch",
        family: "Agility",
        mode: "Active",
        summary: "Peut tenter d'attraper un ballon qui atterrit dans sa zone et gagne +1 sur une passe précise.",
    },
    {
        name: "Diving Tackle",
        family: "Agility",
        mode: "Active",
        summary: "Applique -2 à une esquive saut ou bond adverse quittant sa zone puis se couche dans la case quittée.",
    },
    {
        name: "Dodge",
        family: "Agility",
        mode: "Active",
        summary: "Relance une esquive par tour et protège du résultat Stumble sur bloc adverse.",
        elite: true,
    },
    {
        name: "Hit and Run",
        family: "Agility",
        mode: "Active",
        summary: "Après un blocage ou Stab, se déplace gratuitement d'une case sans marquer ni être marqué.",
    },
    {
        name: "Jump Up",
        family: "Agility",
        mode: "Active",
        summary: "Se relève gratuitement et peut déclarer un bloc en étant à terre avec un test d'Agilité à +1.",
    },
    {
        name: "Leap",
        family: "Agility",
        mode: "Active",
        summary: "Saute une case adjacente en réduisant les malus de saut de 1, incompatible avec Pogo.",
    },
    {
        name: "Safe Pair of Hands",
        family: "Agility",
        mode: "Active",
        summary: "Avant de tomber avec le ballon, place la balle dans une case adjacente inoccupée.",
    },
    {
        name: "Sidestep",
        family: "Agility",
        mode: "Active",
        summary: "Choisit la case de poussée adjacente, si aucune libre l'effet ne s'applique pas.",
    },
    {
        name: "Sprint",
        family: "Agility",
        mode: "Active",
        summary: "Peut tenter un Rush supplémentaire pendant une action de Mouvement.",
    },
    {
        name: "Sure Feet",
        family: "Agility",
        mode: "Active",
        summary: "Relance un jet de Rush par tour.",
    },
    {
        name: "Dirty Player",
        family: "Devious",
        mode: "Active",
        summary: "+1 sur un jet d'Armure ou de Blessure lors d'une agression.",
    },
    {
        name: "Eye Gouge",
        family: "Devious",
        mode: "Active",
        summary: "Quand il pousse un adversaire, la cible ne peut plus fournir d'assist avant sa prochaine activation.",
    },
    {
        name: "Fumblerooski",
        family: "Devious",
        mode: "Active",
        summary: "Pendant un mouvement avec la balle, peut la déposer sur une case quittée sans turnover.",
    },
    {
        name: "Lethal Flight",
        family: "Devious",
        mode: "Active",
        summary: "Si un atterrissage sur un adversaire le met au sol, +1 Armure ou Blessure et gagne les SPP correspondants.",
    },
    {
        name: "Lone Fouler",
        family: "Devious",
        mode: "Active",
        summary: "Si aucune assistance n'est présente lors d'une agression, peut relancer un jet d'Armure raté.",
    },
    {
        name: "Pile Driver",
        family: "Devious",
        mode: "Active",
        summary: "Après avoir mis au sol sur un bloc, effectue une agression gratuite puis se couche.",
    },
    {
        name: "Put the Boot In",
        family: "Devious",
        mode: "Active",
        summary: "Fournit un assist offensif pour une agression même en étant marqué.",
    },
    {
        name: "Quick Foul",
        family: "Devious",
        mode: "Active",
        summary: "Peut continuer son mouvement après avoir effectué une agression.",
    },
    {
        name: "Saboteur",
        family: "Devious",
        mode: "Active",
        summary: "Quand mis au sol par un bloc, sur 4+ l'adversaire est aussi mis au sol, puis ce joueur est KO automatique.",
    },
    {
        name: "Shadowing",
        family: "Devious",
        mode: "Active",
        summary: "Sur 4+, suit un adversaire qui esquive depuis sa zone de tacle, jusqu'à un nombre d'usages égal à son Mouvement.",
    },
    {
        name: "Sneaky Git",
        family: "Devious",
        mode: "Active",
        summary: "Pas d'expulsion sur double naturel si l'armure n'est pas percée lors d'une agression.",
    },
    {
        name: "Violent Innovator",
        family: "Devious",
        mode: "Active",
        summary: "Gagne des PSP quand une Action Spéciale de ce joueur cause une Élimination. Réservé aux joueurs ayant un Trait d'Action Spéciale.",
    },
    {
        name: "Block",
        family: "General",
        mode: "Active",
        summary: "Peut ignorer un Both Down lors d'une action de bloc qui l'implique.",
        elite: true,
    },
    {
        name: "Dauntless",
        family: "General",
        mode: "Active",
        summary: "Peut égaler la Force d'une cible plus forte en réussissant un jet contre son écart de Force.",
    },
    {
        name: "Fend",
        family: "General",
        mode: "Active",
        summary: "Empêche le suivi lorsqu'il est poussé sur un bloc, sauf contre Juggernaut ou Ball & Chain.",
    },
    {
        name: "Frenzy",
        family: "General",
        mode: "Active",
        summary: "Doit suivre et réaliser un second bloc si la cible poussée reste debout, en dépensant du mouvement.",
    },
    {
        name: "Kick",
        family: "General",
        mode: "Active",
        summary: "Réduit la déviation du coup d'envoi à D3 cases en tant que botteur.",
    },
    {
        name: "Pro",
        family: "General",
        mode: "Active",
        summary: "Sur 3+, relance un dé pendant son activation sauf jets d'armure, blessure, sortie ou hors activation.",
    },
    {
        name: "Steady Footing",
        family: "General",
        mode: "Active",
        summary: "Sur un 6, ignore une chute ou mise au sol et continue son activation sans turnover.",
    },
    {
        name: "Strip Ball",
        family: "General",
        mode: "Active",
        summary: "Sur une poussée d'un porteur, la balle tombe dans la case de poussée avant résolution.",
    },
    {
        name: "Sure Hands",
        family: "General",
        mode: "Active",
        summary: "Relance un ramassage de balle et ignore Strip Ball.",
    },
    {
        name: "Tackle",
        family: "General",
        mode: "Active",
        summary: "Empêche Dodge lors d'une esquive depuis sa zone et annule Dodge sur un résultat Stumble.",
    },
    {
        name: "Taunt",
        family: "General",
        mode: "Active",
        summary: "Quand il est poussé, peut forcer l'adversaire à suivre, sauf cible Rooted.",
    },
    {
        name: "Wrestle",
        family: "General",
        mode: "Active",
        summary: "Sur Both Down choisi, place les deux joueurs à terre sans jet d'armure et sans turnover pour l'attaquant.",
    },
    {
        name: "Big Hand",
        family: "Mutation",
        mode: "Active",
        summary: "Ignore les malus pour ramasser le ballon.",
    },
    {
        name: "Claws",
        family: "Mutation",
        mode: "Passive",
        summary: "Sur un bloc réussi, brise l'armure sur un 8+ naturel avant modifications.",
    },
    {
        name: "Disturbing Presence",
        family: "Mutation",
        mode: "Passive",
        summary: "-1 aux tests de passe, d'interférence ou de réception pour les adversaires dans 3 cases.",
    },
    {
        name: "Extra Arms",
        family: "Mutation",
        mode: "Active",
        summary: "+1 pour attraper, ramasser ou intercepter le ballon.",
    },
    {
        name: "Foul Appearance",
        family: "Mutation",
        mode: "Passive",
        summary: "Sur 1, annule une action de bloc ou spéciale visant ce joueur avant les dés.",
    },
    {
        name: "Horns",
        family: "Mutation",
        mode: "Active",
        summary: "+1 Force durant un Blitz.",
    },
    {
        name: "Iron Hard Skin",
        family: "Mutation",
        mode: "Passive",
        summary: "Les jets d'armure contre ce joueur ne peuvent être modifiés et Claws n'a pas d'effet.",
    },
    {
        name: "Monstrous Mouth",
        family: "Mutation",
        mode: "Active",
        summary: "Relance un catch, annule Strip Ball et peut immobiliser une cible adjacente sur 3+ avec Chomp.",
    },
    {
        name: "Prehensile Tail",
        family: "Mutation",
        mode: "Active",
        summary: "-1 au test d'Agilité pour quitter sa zone de tacle en esquive saut ou bond.",
    },
    {
        name: "Tentacles",
        family: "Mutation",
        mode: "Active",
        summary: "Jet de D6 + Force contre Force adverse pour empêcher de quitter la zone de tacle.",
    },
    {
        name: "Two Heads",
        family: "Mutation",
        mode: "Active",
        summary: "+1 aux tests d'esquive.",
    },
    {
        name: "Very Long Legs",
        family: "Mutation",
        mode: "Passive",
        summary: "+1 aux sauts et bonds, +2 aux interceptions et ignore Cloud Burster.",
    },
    {
        name: "Accurate",
        family: "Passing",
        mode: "Active",
        summary: "+1 PA sur une passe courte ou rapide.",
    },
    {
        name: "Cannoneer",
        family: "Passing",
        mode: "Active",
        summary: "+1 PA sur une passe longue ou bombe.",
    },
    {
        name: "Cloud Burster",
        family: "Passing",
        mode: "Active",
        summary: "Aucune interception possible lorsqu'il effectue une passe.",
    },
    {
        name: "Dump-Off",
        family: "Passing",
        mode: "Active",
        summary: "Quand il est ciblé, effectue immédiatement une passe rapide sans turnover avant la résolution de l'action adverse.",
    },
    {
        name: "Give and Go",
        family: "Passing",
        mode: "Active",
        summary: "Après une passe rapide ou un hand-off réussi, poursuit son mouvement si aucun turnover n'est causé.",
    },
    {
        name: "Hail Mary Pass",
        family: "Passing",
        mode: "Active",
        summary: "Déclare n'importe quelle case comme cible, passe traitée comme bombe longue, toujours imprécise et non interceptable.",
    },
    {
        name: "Leader",
        family: "Passing",
        mode: "Passive",
        summary: "Ajoute une relance d'équipe tant qu'un porteur du skill est sur le terrain au début de la mi-temps.",
    },
    {
        name: "Nerves of Steel",
        family: "Passing",
        mode: "Active",
        summary: "Ignore les modificateurs de marquage pour une passe ou une réception.",
    },
    {
        name: "On the Ball",
        family: "Passing",
        mode: "Active",
        summary: "Peut se déplacer de 3 cases sans rush lors d'une passe adverse ou après la déviation d'engagement.",
    },
    {
        name: "Pass",
        family: "Passing",
        mode: "Active",
        summary: "Relance un test de PA raté lors d'une passe.",
    },
    {
        name: "Running Pass",
        family: "Passing",
        mode: "Active",
        summary: "Après une passe rapide réussie, continue son mouvement avec le déplacement restant.",
    },
    {
        name: "Punt",
        family: "Passing",
        mode: "Active",
        summary: "Action spéciale de dégagement avec gabarit, sans turnover tant que la balle ne finit pas chez l'adversaire ou dans le public.",
    },
    {
        name: "Safe Pass",
        family: "Passing",
        mode: "Active",
        summary: "Sur un 1 naturel en PA, conserve la balle et termine l'activation sans turnover.",
    },
    {
        name: "Arm Bar",
        family: "Strength",
        mode: "Active",
        summary: "+1 Armure ou Blessure si un adversaire échoue une esquive, un saut ou bond depuis sa zone de tacle.",
    },
    {
        name: "Brawler",
        family: "Strength",
        mode: "Active",
        summary: "Relance un Both Down lors d'un bloc déclaré par ce joueur.",
    },
    {
        name: "Break Tackle",
        family: "Strength",
        mode: "Active",
        summary: "Une esquive par tour avec bonus selon la Force : +1 (F3 ou moins), +2 (F4), +3 (F5 ou plus).",
    },
    {
        name: "Bullseye",
        family: "Strength",
        mode: "Active",
        summary: "Sur un Superb Throw d'un lancer de coéquipier, pas de dispersion avant atterrissage.",
    },
    {
        name: "Grab",
        family: "Strength",
        mode: "Active",
        summary: "Choisit la case de poussée et annule Sidestep; incompatible avec Frenzy.",
    },
    {
        name: "Guard",
        family: "Strength",
        mode: "Active",
        summary: "Fournit des assists offensifs et défensifs même en étant marqué.",
        elite: true,
    },
    {
        name: "Juggernaut",
        family: "Strength",
        mode: "Active",
        summary: "En Blitz, Both Down devient poussée et la cible ne peut pas utiliser Fend Stand Firm ou Wrestle.",
    },
    {
        name: "Mighty Blow",
        family: "Strength",
        mode: "Active",
        summary: "Ajoute +1 à un jet d'Armure ou de Blessure sur un bloc réussi même en cas de chute.",
        elite: true,
    },
    {
        name: "Multiple Block",
        family: "Strength",
        mode: "Active",
        summary: "Déclare deux blocs simultanés sur des cibles différentes avec -2 Force et sans suivi, incompatible avec Frenzy.",
    },
    {
        name: "Stand Firm",
        family: "Strength",
        mode: "Active",
        summary: "Peut refuser d'être poussé, y compris en chaîne, sans annuler un second bloc de Frenzy.",
    },
    {
        name: "Strong Arm",
        family: "Strength",
        mode: "Active",
        summary: "+1 PA pour un lancer de coéquipier, nécessite le trait Throw Team-mate.",
    },
    {
        name: "Thick Skull",
        family: "Strength",
        mode: "Passive",
        summary: "Est sonné sur 8 et KO sur 9; avec Stunty KO sur 8 et sonné sur 7.",
    },
    {
        name: "Always Hungry",
        family: "Traits",
        mode: "Active",
        summary: "Avant un lancer de coéquipier, sur 1 tente de le manger avec risque de mort et turnover.",
    },
    {
        name: "Animal Savagery",
        family: "Traits",
        mode: "Passive",
        summary: "Après déclaration d'action, sur 1-3 frappe un coéquipier adjacent, sinon devient Distracted.",
    },
    {
        name: "Animosity (X)",
        family: "Traits",
        mode: "Active",
        summary: "Sur une passe ou transmission vers le mot-clé indiqué, sur 1 refuse et termine son activation.",
    },
    {
        name: "Ball & Chain",
        family: "Traits",
        mode: "Active",
        summary: "Ne peut faire qu'une action Boulet avec mouvement aléatoire et blocs automatiques sur contact.",
    },
    {
        name: "Bone Head",
        family: "Traits",
        mode: "Passive",
        summary: "Sur 1 après déclaration, devient Distracted et perd ses zones de tacle pour le tour.",
    },
    {
        name: "Breathe Fire",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale sur une cible adjacente, sur 4+ la met à terre ou la sonne puis l'activation se termine.",
    },
    {
        name: "Bloodlust (X+)",
        family: "Traits",
        mode: "Passive",
        summary: "Test à l'activation, en échec doit mordre un Thrall adjacent ou cause turnover et lâche la balle.",
    },
    {
        name: "Bombardier",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale pour lancer une bombe suivant les règles de passe, sans mouvement préalable.",
    },
    {
        name: "Chainsaw",
        family: "Traits",
        mode: "Active",
        summary: "Action tronçonneuse pour un jet d'armure à +3 sur 2+, kickback sur 1 et vulnérabilité accrue.",
    },
    {
        name: "Decay",
        family: "Traits",
        mode: "Passive",
        summary: "+1 aux jets de blessure subis par ce joueur.",
    },
    {
        name: "Drunkard",
        family: "Traits",
        mode: "Passive",
        summary: "-1 sur chaque Rush tenté.",
    },
    {
        name: "Hatred (X)",
        family: "Traits",
        mode: "Passive",
        summary: "Réussit à relancer un Both Down lorsqu'il bloque une cible ayant le mot-clé indiqué.",
    },
    {
        name: "Hypnotic Gaze",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale adjacente, sur 3+ rend la cible Distracted puis termine l'activation.",
    },
    {
        name: "Insignificant",
        family: "Traits",
        mode: "Passive",
        summary: "Le roster ne peut pas contenir plus de joueurs avec ce trait que de joueurs sans ce trait.",
    },
    {
        name: "Kick Team-mate",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale pour botter un coéquipier comme un lancer, avec blessure en cas de fumble.",
    },
    {
        name: "Loner (X+)",
        family: "Traits",
        mode: "Passive",
        summary: "Doit réussir un D6 pour utiliser une relance d'équipe, sinon la relance est perdue.",
    },
    {
        name: "My Ball",
        family: "Traits",
        mode: "Passive",
        summary: "Ne peut pas volontairement céder le ballon et ne peut pas déclarer de passe ou hand-off.",
    },
    {
        name: "No Ball",
        family: "Traits",
        mode: "Passive",
        summary: "Ne peut ni porter, ni ramasser, ni intercepter le ballon, échoue automatiquement.",
    },
    {
        name: "Pick-me-up",
        family: "Traits",
        mode: "Active",
        summary: "Fin de tour adverse, sur 5+ relève un coéquipier à 3 cases, un joueur relevé ainsi ne peut pas réutiliser ce trait.",
    },
    {
        name: "Plague Ridden",
        family: "Traits",
        mode: "Passive",
        summary: "Une fois par match, transforme une victime morte en nouveau lineman sauf cibles interdites.",
    },
    {
        name: "Pogo",
        family: "Traits",
        mode: "Active",
        summary: "Effectue un saut sur une case adjacente en ignorant les modificateurs de saut, incompatible avec Leap.",
    },
    {
        name: "Projectile Vomit",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale, sur 2+ vomit une cible adjacente avec jet d'armure non modifié, sur 1 s'auto-vomit.",
    },
    {
        name: "Really Stupid",
        family: "Traits",
        mode: "Passive",
        summary: "Après déclaration, sur 1-3 devient Distracted, avec +2 au jet si adjacents valides.",
    },
    {
        name: "Regeneration",
        family: "Traits",
        mode: "Passive",
        summary: "Sur 4+ ignore une sortie et va en réserve, sinon subit la blessure.",
    },
    {
        name: "Right Stuff",
        family: "Traits",
        mode: "Passive",
        summary: "Peut être lancé par un coéquipier avec Throw Team-mate même en étant à terre.",
    },
    {
        name: "Secret Weapon",
        family: "Traits",
        mode: "Passive",
        summary: "Est expulsé à la fin d'un drive auquel il a participé, même s'il n'est plus sur le terrain.",
    },
    {
        name: "Stab",
        family: "Traits",
        mode: "Active",
        summary: "Action spéciale infligeant un jet d'armure non modifié à une cible adjacente, remplaçable en Blitz.",
    },
    {
        name: "Stunty",
        family: "Traits",
        mode: "Passive",
        summary: "Ignore les malus de zones pour esquiver, -1 aux interceptions et utilise la table de blessure Stunty.",
    },
    {
        name: "Swoop",
        family: "Traits",
        mode: "Active",
        summary: "Lors d'un lancer, peut choisir une trajectoire avec gabarit et relancer l'atterrissage.",
    },
    {
        name: "Take Root",
        family: "Traits",
        mode: "Passive",
        summary: "Sur 1 après déclaration, devient Rooted et ne peut plus bouger ni suivre jusqu'à la fin du drive ou mise au sol.",
    },
    {
        name: "Throw Team-mate",
        family: "Traits",
        mode: "Active",
        summary: "Peut déclarer une action de lancer de coéquipier.",
    },
    {
        name: "Timmm-ber!",
        family: "Traits",
        mode: "Passive",
        summary: "Si Mouvement 2 ou moins, gagne +1 pour se relever par coéquipier adjacent, 1 naturel échoue.",
    },
    {
        name: "Titchy",
        family: "Traits",
        mode: "Passive",
        summary: "Applique +1 aux esquives et ne pénalise pas les adversaires qui esquivent dans sa zone.",
    },
    {
        name: "Trickster",
        family: "Traits",
        mode: "Active",
        summary: "Quand ciblé par un bloc ou action spéciale, se place sur une case adjacente avant la résolution.",
    },
    {
        name: "Unchannelled Fury",
        family: "Traits",
        mode: "Passive",
        summary: "Après déclaration, sur 1-3 devient inactif, avec +2 au jet si bloc ou blitz déclaré.",
    },
    {
        name: "Unsteady",
        family: "Traits",
        mode: "Passive",
        summary: "Ne peut pas déclarer d'action Secure the Ball.",
    },
];
